import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { RoutePathEnum } from "~Shared/router/RoutePath.enum"
import { generatePath } from "~Shared/utils/routing.utils"

export const NotFoundPage = () => {
    const { t } = useTranslation()

    return (
        <div>
            <h2 className="p-0 text-center sm:text-left">{t("view:error.not_found.title")}</h2>
            <p className="mb-20 text-center sm:text-left">{t("view:error.not_found.message")}</p>

            <div className="text-center sm:text-left">
                <Link to={generatePath(RoutePathEnum.ROOT)}>{t("nav:go_back_to_homepage")}</Link>
            </div>
        </div>
    )
}
